var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuzball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1627909098672,
    className: "icon",
    viewBox: "0 0 1344 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1251,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 262.5,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M672 384c-70.592 0-128 57.408-128 128s57.408 128 128 128c70.624 0 128-57.408 128-128s-57.376-128-128-128z m0 192c-35.264 0-64-28.704-64-64 0-35.264 28.736-64 64-64 35.296 0 64 28.736 64 64 0 35.296-28.704 64-64 64zM1312 0H32a32 32 0 0 0-32 32v960a32 32 0 0 0 32 32h1280a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM224 456.928c19.04 11.072 32 31.52 32 55.072 0 23.584-12.96 44-32 55.104v-110.176zM64 288h96v448H64V288z m640 672v-224a32 32 0 1 0-64 0v224H64v-160h128a32 32 0 0 0 32-32v-132.544c55.072-14.304 96-63.968 96-123.456 0-59.456-40.928-109.152-96-123.456V256a32 32 0 0 0-32-32H64V64h576v224a32 32 0 1 0 64 0V64h576v160h-128a32 32 0 0 0-32 32v132.544c-55.04 14.304-96 64-96 123.456 0 59.488 40.96 109.152 96 123.456V768a32 32 0 0 0 32 32h128v160H704zM1184 288h96v448h-96V288z m-64 279.104c-19.008-11.104-32-31.52-32-55.104 0-23.552 12.992-44 32-55.072v110.176z",
    "p-id": 1252
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuzball);
export default __webpack_public_path__ + "static/media/fuzball.377c7122.svg";
export { ForwardRef as ReactComponent };